/**
 * Core board types. Everything here is plain, serializable data so it can be
 * saved, shared in a URL, undone, and simulated headlessly.
 */

/** Quarter turns. 0 = pointing +x (east), 1 = +y (south), 2 = -x, 3 = -y. */
export type Rot = 0 | 1 | 2 | 3;

export type PartType =
  'battery' | 'wire' | 'jumper' | 'lamp' | 'switch' | 'button' | 'motor' | 'led' | 'buzzer' | 'resistor';

export type PropValue = string | number | boolean;
export type PartProps = Record<string, PropValue>;

/** A part sitting on the board. `x,y` is the stud of pin 0 (the part's "anchor"). */
export interface Placement {
  id: string;
  type: PartType;
  x: number;
  y: number;
  rot: Rot;
  /** Stack height: 0 sits on the board, 1 sits on top of a layer-0 part, … (computed by the board). */
  layer: number;
  props: PartProps;
}

export interface Cell {
  x: number;
  y: number;
}

export const DIRS: readonly Cell[] = [
  { x: 1, y: 0 },
  { x: 0, y: 1 },
  { x: -1, y: 0 },
  { x: 0, y: -1 },
];

export const cellKey = (x: number, y: number): string => `${x},${y}`;
